var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pt-4 pb-4",attrs:{"id":"page-title"}},[_c('div',{staticClass:"col-12",class:_vm.align},[_c('h4',{staticClass:"text-center text-lg-left"},[_c('i',{staticClass:"fa fa-star"}),_vm._v(" "+_vm._s(_vm.title)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }